var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Buttonmain"},[_c('el-form-item',{attrs:{"label-width":_vm.currentField.labelWidth-50 + 'px'}},[_c('el-button',{staticClass:"form__button",attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.currentField.buttonText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }